$(document).ready(function(){
    $('.pill').click(function(e){
        e.preventDefault()

        $('.pill.active').removeClass('active')
        $(this).addClass('active')

        const area = $(this).data('target')

        $('.pill-content.show').removeClass('show')
        $(area).addClass('show')
    })
})



// WEBPACK FOOTER //
// ./assets/js/homepage.js